import React, { useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/dist/sweetalert2.css';
import Layout from '../../../Components/Layout';
import Breadcrumb from '../Component/Breadcrumb';
import Sidebar from '../../Dashboard/Component/Siderbar';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Invoice from './Invoice';
import Voucher from './Voucher';
import config from '../../../config';
import DataTable from "react-data-table-component";
import { FaEye } from "react-icons/fa"; // Göz ikonu için
import { MdOutlineCancel } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { FaRegClock } from "react-icons/fa";
import { IoListCircleOutline } from "react-icons/io5";
import Select from "react-select";
import { utils, writeFile } from 'xlsx';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { FaEuroSign, FaDollarSign, FaLiraSign } from "react-icons/fa";
import { useCurrency } from '../../../context/CurrencyContext';
import { getPrice, formatPrice } from '../../../services/priceUtils';
import { usePriceConverter } from '../../../hooks/usePriceConverter';


export default function List() {
    const { selectedCurrency, formatPrice: formatCurrencyPrice } = useCurrency();
    const [originalAmount, setOriginalAmount] = useState(0);
    const [formattedTotalAmount, setFormattedTotalAmount] = useState('0.00');
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const location = useLocation();
    const [markup, setMarkup] = useState();
    const [tableLoading, setTableLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [orders, setOrders] = useState([]);
    const [stats, setStats] = useState([]);
    const [perPage, setPerPage] = useState(15);
    const [currentPage, setCurrentPage] = useState(1);
    const agencyId = location.state?.agencyId ?? null;
    const [totalRows, setTotalRows] = useState(0);
    const [sortedData, setSortedData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
    const { hotelSlug, roomSlug } = useParams(); // URL'den parametreyi al
    const [deleteProcess, setDeleteProcess] = useState(0);
    const [deleteId, setDeleteId] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [modalData, setModalData] = useState(null);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [expandedOrders, setExpandedOrders] = useState({});
    const [expandedHotels, setExpandedHotels] = useState({});

    const [formData, setFormData] = useState({
        orderNumber: "",
        agencyName: "",
        orderDate: "",
        status: null,
        checkInDate: "",
        checkOutDate: "",
        hotelName: "",
        countryId: "",
        stateId: "",
        cityId: "",
        holder: ""
    });
    
    const handleFormReset = () => {
        setFormData({
            orderNumber: "",
            agencyName: "",
            orderDate: "",
            status: null,
            checkInDate: "",
            checkOutDate: "",
            hotelName: "",
            countryId: "",
            stateId: "",
            cityId: "",
            holder: ""
        });
        
        setSelectedCountry(null);
        setSelectedState(null);
        setSelectedCity(null);
        
        fetchOrders(currentPage, perPage, null, null, null, null, null, null, null, null, null, null, null);
    };

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data Submitted:", formData);

        fetchOrders(
            currentPage,
            perPage,
            formData.orderNumber || null,
            formData.agencyName || null,
            formData.orderDate || null,
            formData.status?.value || null,
            formData.checkInDate || null,
            formData.checkOutDate || null,
            formData.hotelName || null,
            formData.countryId || null,
            formData.stateId || null,
            formData.cityId || null,
            formData.holder || null
        );

    };

    const statusOptions = [
        { value: "refunded", label: "Refunded" },
        { value: "paid", label: "Paid" },
        { value: "failed", label: "Failed" },
        { value: "pending", label: "Pending" },
    ];

    const handleChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
        console.log("Selected Status:", selectedOption);
    };
    const fetchAgencies = async (searchTerm = "") => {
        try {
            const response = await axios.get(
                `${config.API_BASE_URL_V1}/order/search-sub-agency?search=${searchTerm}`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log('response: ',response)
    
            const formattedOptions = response.data.data.map((agency) => ({
                value: agency.id,
                label: agency.name,
            }));
    
            setOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching agencies:", error);
        }
    };

    useEffect(() => {
        fetchAgencies();
    }, []);

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        fetchAgencies(newValue);
    };

    const fetchOrders = async (page, perPage, orderNumber = null, agencyName = null, orderDate = null, paymentStatus = null, checkInDate = null, checkOutDate = null, hotelName = null, countryId = null, stateId = null, cityId = null, holder = null) => {
        setTableLoading(true)
        setButtonLoading(true);
        try {
            const params = {
                page: page,
                perPage: perPage,
            };
            
            if (orderNumber != null) {
                params.search = orderNumber;
            }
            if (agencyName != null) {
                params.agencyName = agencyName;
            }
            if (orderDate != null) {
                params.orderDate = orderDate;
            }
            if (paymentStatus != null) {
                params.paymentStatus = paymentStatus;
            }
            if (checkInDate != null) {
                params.checkInDate = checkInDate;
            }
            if (checkOutDate != null) {
                params.checkOutDate = checkOutDate;
            }
            if (hotelName != null) {
                params.hotelName = hotelName;
            }
            if (countryId != null) {
                params.countryId = countryId;
            }
            if (stateId != null) {
                params.stateId = stateId;
            }
            if (cityId != null) {
                params.cityId = cityId;
            }
            if (holder != null) {
                params.holder = holder;
            }
            
            const response = await axios.get(`${config.API_BASE_URL_V1}order`, {
                params,
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json",
                },
            });
            
            if (response.data.status === "success") {
                setOrders(response.data.data.data);
                setTotalRows(response.data.data.meta.total);
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
        finally {
            setButtonLoading(false);
            setTableLoading(false);
        }
    };

    useEffect(() => {
        const updateTotalAmount = async () => {
            if (originalAmount > 0) {
                try {
                    const formattedAmount = await getPrice(originalAmount, userData.token, selectedCurrency);
                    setFormattedTotalAmount(formattedAmount);
                } catch (error) {
                    console.error("Error updating total amount:", error);
                }
            }
        };

        updateTotalAmount();
    }, [selectedCurrency, originalAmount, userData?.token]);

    const fetchStats = async () => {
        try {
            const response = await axios.get(
                `${config.API_BASE_URL_V1}order/stats`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.data.status === "success") {
                setStats(response.data.data);
                if (response.data.data.total_amount) {
                    setOriginalAmount(response.data.data.total_amount);
                }
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    useEffect(() => {
        fetchCountries();
        fetchStats();
        fetchOrders(currentPage, perPage, agencyId);
    }, [currentPage, perPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    const dateOptions = {
        day: "2-digit",
        month: "short",
        year: "numeric"
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-"; // Eğer tarih boşsa "-" göster
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    };

    const columns = useMemo(() => {
        let baseColumns = [
            {
                name: "Booking Number",
                selector: (row) => row.order_number,
                sortable: true,
                width: "180px",
            },
            {
                name: "Guest",
                selector: (row) => `${row.holder_info?.name || ''} ${row.holder_info?.surname || ''}`,
                sortable: true,
                width: "150px",
            },
            {
                name: "Booking Date",
                selector: (row) => formatDate(row.order_datetime),
                sortable: true,
            },
            {
                name: "Hotel",
                selector: (row) => (row.order_items?.[0]?.hotel?.name ?? '-'),
                sortable: true,
                width:'200px'
            },
            {
                name: "Check-in Date",
                selector: (row) => formatDate(row.order_items?.[0]?.check_in_date),
            },
            {
                name: "Check-out Date",
                selector: (row) => formatDate(row.order_items?.[0]?.check_out_date),
            },
            {
                name: "Payment Status",
                sortable: true,
                cell: (row) => (
                    <div
                        style={{
                            backgroundColor:
                                row.order_items?.[0]?.payment_status === "failed"
                                    ? "red"
                                    : row.order_items?.[0]?.payment_status === "refunded"
                                    ? "yellow"
                                    : row.order_items?.[0]?.payment_status === "paid"
                                    ? "green"
                                    : "orange",
                            color: "white",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            textAlign: "center",
                            fontWeight: "bold",
                            minWidth: "80px",
                        }}
                    >
                        <p style={row.order_items?.[0]?.payment_status === "refunded" ? { color: "black" } : { color: "white" }}>
                            {row.order_items?.[0]?.payment_status || '-'}
                        </p>
                    </div>
                ),
            },
            {
                name: "Booking Status",
                sortable: true,
                cell: (row) => (
                    <div
                        style={{
                            backgroundColor:
                                row.order_items?.[0]?.status === "canceled"
                                    ? "red"
                                    : row.order_items?.[0]?.status === "success"
                                    ? "green"
                                    : "orange",
                            color: "white",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            textAlign: "center",
                            fontWeight: "bold",
                            minWidth: "80px",
                        }}
                    >
                        <p style={row.order_items?.[0]?.status === "canceled" ? { color: "black" } : { color: "white" }}>
                            {row.order_items?.[0]?.status || '-'}
                        </p>
                    </div>
                ),
            },
            {
                name: "Payment Method",
                selector: (row) => row.order_items?.[0]?.payment_method || '-',
                width:'150px',
                cell: (row) => <p className="text-capitalize" style={{ paddingInline:'10px', paddingBlock:'5px', border:'solid', borderColor:'gray', borderRadius:'5px', width:'200px', textAlign:'center', borderWidth:'thin' }}>{row.order_items?.[0]?.payment_method?.toLowerCase() || '-'}</p>,
                center:true
            },
            {
                name: "Total Price",
                width:'100px',
                center:true,
                fontWeight:'bold',
                selector: (row) => row.total_with_markup_price || '0.00',
                cell: (row) => <p>{row.total_with_markup_price || '0.00'} {row.currency?.symbol || 'EUR'}</p>,
            },
        ];

        // Eğer userData.isOwner true ise ek olarak iki sütunu ekle
        if (userData?.user?.isOwner === true) {
            baseColumns.push(
                {
                    name: "No-markup Price",
                    selector: (row) => row.total_without_markup_price || '0.00',
                    cell: (row) => <p>{row.total_without_markup_price || '0.00'} {row.currency?.symbol || 'EUR'}</p>,
                    width:'100px',
                    center:true,
                },
                {
                    name: "With-markup Price",
                    selector: (row) => row.total_with_markup_price || '0.00',
                    cell: (row) => <p>{row.total_with_markup_price || '0.00'} {row.currency?.symbol || 'EUR'}</p>,
                    width:'100px',
                    center:true,
                },
                {
                    name: "Profit",
                    selector: (row) => {
                        const withoutMarkup = parseFloat(row.total_without_markup_price) || 0;
                        const withMarkup = parseFloat(row.total_with_markup_price) || 0;
                        return withoutMarkup === withMarkup ? '0' : withMarkup - withoutMarkup;
                    },
                    cell: (row) => {
                        const withoutMarkup = parseFloat(row.total_without_markup_price) || 0;
                        const withMarkup = parseFloat(row.total_with_markup_price) || 0;
                        const profit = withoutMarkup === withMarkup ? 0 : ((withMarkup - withoutMarkup) / withoutMarkup * 100);
                        return <p className="text-success">{profit.toFixed(0)}%</p>;
                    },
                    width:'200px',
                    center:true,
                }
            );
        }

        baseColumns.push({
            name: "Settings",
            cell: (row) => (
                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                        onClick={() => handleView(row.id)}
                    >
                        <i className="isax isax-eye"></i>
                        Edit
                    </button>
                </div>
            ),
            width: "100px",
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        });

        return baseColumns;
    }, [userData?.user?.isOwner]);




    console.log('userData2: ',userData)
    
    useEffect(() => {
        if (orders.length > 0) {
            setSortedData(orders); // orders geldiğinde sortedData'yı da güncelle
        }
    }, [orders]); // orders değiştiğinde sortedData'yı güncelle
    
    console.log('orders: ',orders)
    
    const confirmDelete = async () => {
        console.log(`Delete room with ID: ${deleteId}`);
        try {
            const response = await axios.delete(
                `${config.API_BASE_URL_V1}hotel/${localStorage.getItem('hotelId')}/room/${localStorage.getItem('roomId')}/delete-price/${deleteId}`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`, 
                    },
                }
            );

            setDeleteProcess(deleteProcess+1);
    
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Room deleted successfully",
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error) {
            console.error("Error deleting room:", error.response ? error.response.data : error.message);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Failed to delete the room",
                showConfirmButton: true,
            });
        } finally {
            setDeleteId(null); // Reset deleteId after deletion
        }
    };
   
    const handleView = (id) => {
        navigate(`/dashboard-bookings-detail`, {state: {id}});

    }
    const handleExportToExcel = () => {
        if (!orders || orders.length === 0) {
            console.warn("No data available to export");
            return;
        }
    
        // Excel'de kullanacağımız başlıkları manuel olarak belirleyelim
        const headers = [
            "Booking Number", "Booking Date", "Check-in Date", "Check-out Date",
            "Agency ID", "User ID", "Hotel ID", "Hotel Name", "Payment Method",
            "Payment Status", "Currency ID", "With Markup Price", "Without Markup Price",
            "Holder First Name", "Holder Last Name", "Holder Email", "Holder Phone",
            "Delivery Email", "Delivery Phone", "Provider ID", "Provider Type",
            "Tax Type", "Tax Amount", "Tax Percentage", "Notes"
        ];
    
        // DataTable içindeki görünen verileri Excel formatına uygun hale getir
        const data = orders.map(order => ({
            "Booking Number": order.order_number || "",
            "Booking Date": order.order_date || "",
            "Check-in Date": order.check_in_date || "",
            "Check-out Date": order.check_out_date || "",
            "Agency ID": order.agency_id || "",
            "User ID": order.user_id || "",
            "Hotel ID": order.hotel?.id || "",
            "Hotel Name": order.hotel?.name || "",
            "Payment Method": order.payment_method || "",
            "Payment Status": order.payment_status || "",
            "Currency ID": order.currency_id || "",
            "With Markup Price": order.with_markup_price || "",
            "Without Markup Price": order.without_markup_price || "",
            "Holder First Name": order.holder_info?.firstName || "",
            "Holder Last Name": order.holder_info?.lastName || "",
            "Holder Email": order.holder_info?.email || "",
            "Holder Phone": order.holder_info?.phone || "",
            "Delivery Email": order.delivery_email || "",
            "Delivery Phone": order.delivery_phone || "",
            "Provider ID": order.provider_id || "",
            "Provider Type": order.provider_type || "",
            "Tax Type": order.taxes_info?.tax_type || "",
            "Tax Amount": order.taxes_info?.tax_amount || "",
            "Tax Percentage": order.taxes_info?.tax_percentage || "",
            "Notes": order.notes || ""
        }));
    
        // Sheet oluştur ve veriyi ekleyerek çalışma kitabına (workbook) aktar
        const worksheet = utils.json_to_sheet(data, { header: headers });
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Bookings");
    
        // Dosya olarak kaydetme işlemi
        writeFile(workbook, "bookings.xlsx");
    };

    const handleExportToPdf = async () => {
        if (!orders || orders.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Data',
                text: 'No data available to export',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        try {
            // PDF settings
            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4',
                compress: true,
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            // Font and style settings
            doc.setFont("helvetica", "normal");
            doc.setFontSize(18);

            // Logo and Title
            doc.setTextColor(41, 128, 185); // Blue color
            doc.text("Booking Report", doc.internal.pageSize.width / 2, 15, { align: 'center' });
            
            // Subtitle and Date
            doc.setFontSize(10);
            doc.setTextColor(100, 100, 100); // Gray color
            const currentDate = new Date().toLocaleString('en-GB', { 
                dateStyle: 'full', 
                timeStyle: 'medium' 
            });
            doc.text(`Generated Date: ${currentDate}`, 15, 25);

            // Summary Information
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            const totalAmount = orders.reduce((sum, order) => sum + (parseFloat(order.with_markup_price) || 0), 0);
            const totalOrders = orders.length;
            doc.text(`Total Bookings: ${totalOrders}`, 15, 32);
            doc.text(`Total Amount: ${totalAmount.toFixed(2)} $`, 15, 38);

            // Table headers and data
            const tableData = {
                head: [[
                    "Booking No",
                    "Date",
                    "Hotel",
                    "Check-in",
                    "Check-out",
                    "Status",
                    "Payment Method",
                    "Profit"
                ]],
                body: orders.map(order => {
                    const withoutMarkup = parseFloat(order.without_markup_price) || 0;
                    const withMarkup = parseFloat(order.with_markup_price) || 0;
                    const profit = (withMarkup - withoutMarkup).toFixed(2);
                    
                    return [
                        order.order_number || "-",
                        formatDate(order.order_datetime) || "-",
                        order.hotel?.name ? (order.hotel.name.length > 25 ? order.hotel.name.substring(0, 22) + "..." : order.hotel.name) : "-",
                        formatDate(order.check_in_date) || "-",
                        formatDate(order.check_out_date) || "-",
                        order.payment_status?.toUpperCase() || "-",
                        order.payment_method || "-",
                        `${withoutMarkup.toFixed(2)} ${order.currency.code}`,
                        `${withMarkup.toFixed(2)} ${order.currency.code}`,
                        `${profit} ${order.currency.code}`
                    ];
                })
            };

            // Create table
            autoTable(doc, {
                head: tableData.head,
                body: tableData.body,
                startY: 45,
                theme: 'grid',
                styles: {
                    fontSize: 9,
                    cellPadding: 3,
                    lineColor: [200, 200, 200],
                    lineWidth: 0.1,
                    font: "helvetica",
                    halign: 'center',
                    valign: 'middle',
                    minCellHeight: 8
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    halign: 'center',
                    fontSize: 10
                },
                columnStyles: {
                    0: { cellWidth: 25 }, // Order No
                    1: { cellWidth: 25 }, // Date
                    2: { cellWidth: 50 }, // Hotel
                    3: { cellWidth: 25 }, // Check-in
                    4: { cellWidth: 25 }, // Check-out
                    5: { cellWidth: 20 }, // Status
                    6: { cellWidth: 25 }, // Payment Method
                    7: { cellWidth: 20 }  // Profit
                },
                alternateRowStyles: {
                    fillColor: [249, 249, 249]
                },
                margin: { top: 45, left: 10, right: 10 },
                didDrawPage: function (data) {
                    // Page number
                    doc.setFontSize(8);
                    doc.setTextColor(150, 150, 150);
                    doc.text(
                        `Page ${doc.internal.getNumberOfPages()}`,
                        doc.internal.pageSize.width - 20,
                        doc.internal.pageSize.height - 10
                    );

                    // Footer
                    doc.setFontSize(8);
                    doc.setTextColor(150, 150, 150);
                    doc.text(
                        `© ${new Date().getFullYear()} All rights reserved.`,
                        20,
                        doc.internal.pageSize.height - 10
                    );
                }
            });

            // Save PDF
            const fileName = `bookings-${new Date().toISOString().split('T')[0]}.pdf`;
            doc.save(fileName);

            // Success notification
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });

            Toast.fire({
                icon: 'success',
                title: 'PDF has been generated successfully'
            });

        } catch (error) {
            console.error("PDF Generation Error:", error);
            
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'An error occurred while generating PDF: ' + error.message,
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK'
            });
        }
    };

    const fetchCountries = async () => {
        try {
            const response = await axios.get(`${config.API_BASE_URL}geo/countries`);
            setCountries(response.data);
        } catch (err) {
            console.error('Error fetching countries:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch countries',
            });
        }
    };

    const fetchStates = async (countryId) => {
        if (!countryId) return;
        try {
            const response = await axios.get(`${config.API_BASE_URL}geo/states/${countryId}`);
            setStates(response.data);
        } catch (err) {
            console.error('Error fetching states:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch states',
            });
        }
    };

    const fetchCities = async (stateId) => {
        if (!stateId) return;   
        try {
            const response = await axios.get(`${config.API_BASE_URL}geo/cities/${stateId}`);
            setCities(response.data);
        } catch (err) {
            console.error('Error fetching cities:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch cities',
            });
        }
    };

    // Para birimi ikonunu seç
    const getCurrencyIcon = () => {
        switch(selectedCurrency) {
            case 'USD':
                return <FaDollarSign className='fs-36'/>;
            case 'TRY':
                return <FaLiraSign className='fs-36'/>;
            case 'EUR':
            default:
                return <FaEuroSign className='fs-36'/>;
        }
    };

    const toggleOrder = (orderId) => {
        setExpandedOrders(prev => ({
            ...prev,
            [orderId]: !prev[orderId]
        }));
    };

    const toggleHotel = (hotelId) => {
        setExpandedHotels(prev => ({
            ...prev,
            [hotelId]: !prev[hotelId]
        }));
    };

    // Fiyat dönüşümü için state'ler
    const [orderPrices, setOrderPrices] = useState({});
    const [cancellationPrices, setCancellationPrices] = useState({});

    // Sipariş ve iptal fiyatlarını dönüştür
    useEffect(() => {
        const convertPrices = async () => {
            const orderPricesMap = {};
            const cancellationPricesMap = {};

            for (const order of orders) {
                // Ana sipariş fiyatı
                if (order.total_with_markup_price) {
                    const convertedPrice = await getPrice(
                        order.total_with_markup_price,
                        userData.token,
                        selectedCurrency,
                        null,
                        null,
                        order.currency?.code
                    );
                    orderPricesMap[`order_${order.id}`] = convertedPrice;
                }

                // Otel fiyatları
                if (order.grouped_hotels) {
                    for (const hotel of order.grouped_hotels) {
                        if (hotel.total_with_markup_price) {
                            const convertedPrice = await getPrice(
                                hotel.total_with_markup_price,
                                userData.token,
                                selectedCurrency,
                                null,
                                null,
                                hotel.currency?.code
                            );
                            orderPricesMap[`hotel_${hotel.id}`] = convertedPrice;
                        }

                        // Oda fiyatları
                        if (hotel.items) {
                            for (const item of hotel.items) {
                                if (item.with_markup_price) {
                                    const convertedPrice = await getPrice(
                                        item.with_markup_price,
                                        userData.token,
                                        selectedCurrency,
                                        null,
                                        null,
                                        item.currency?.code
                                    );
                                    orderPricesMap[`item_${item.id}`] = convertedPrice;

                                    // İptal politikası fiyatları
                                    if (item.cancellation_policies?.length > 0) {
                                        for (const policy of item.cancellation_policies) {
                                            if (policy.amount) {
                                                const convertedCancellationPrice = await getPrice(
                                                    policy.amount,
                                                    userData.token,
                                                    selectedCurrency,
                                                    null,
                                                    null,
                                                    item.currency?.code
                                                );
                                                cancellationPricesMap[`policy_${item.id}_${policy.from}`] = convertedCancellationPrice;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            setOrderPrices(orderPricesMap);
            setCancellationPrices(cancellationPricesMap);
        };

        convertPrices();
    }, [orders, selectedCurrency, userData?.token]);

    if(loading)
    {
        return (
        <div id="loader-wrapper">
            <div id="loader">
                <span className="loader-line"></span>
            </div>
        </div>
        )
    }

return (
    <Layout>
        <Breadcrumb title="Bookings" />
        <div className="content">
            <div className="container">
                <div className="row">
                    <Sidebar>
                        <div className="row">
                            <div className="col-xl-4">
                                <div className="card" style={{ 
                                    background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <span className="avatar avatar-xl rounded-circle me-3" style={{ 
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                padding: '15px'
                                            }}>
                                                <IoListCircleOutline className='fs-36 text-white'/>
                                            </span>
                                            <div>
                                                <h3 className="text-white mb-1"> { stats?.total_orders ?? '0' } </h3>
                                                <p className="text-white-50 mb-0">Total Booking</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card" style={{ 
                                    background: 'linear-gradient(135deg, #f6c23e 0%, #dda20a 100%)',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <span className="avatar avatar-xl rounded-circle me-3" style={{ 
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                padding: '15px'
                                            }}>
                                                <FaRegClock className='fs-36 text-white'/>
                                            </span>
                                            <div>
                                                <h3 className="text-white mb-1"> { stats?.total_pending_orders ?? '0' } </h3>
                                                <p className="text-white-50 mb-0">Pending Booking</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card" style={{ 
                                    background: 'linear-gradient(135deg, #1cc88a 0%, #13855c 100%)',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <span className="avatar avatar-xl rounded-circle me-3" style={{ 
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                padding: '15px'
                                            }}>
                                                <TiTick className='fs-36 text-white'/>
                                            </span>
                                            <div>
                                                <h3 className="text-white mb-1"> { stats?.total_paid_orders ?? '0' } </h3>
                                                <p className="text-white-50 mb-0">Paid Booking</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card" style={{ 
                                    background: 'linear-gradient(135deg, #e74a3b 0%, #be2617 100%)',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <span className="avatar avatar-xl rounded-circle me-3" style={{ 
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                padding: '15px'
                                            }}>
                                                <MdOutlineCancel className='fs-36 text-white'/>
                                            </span>
                                            <div>
                                                <h3 className="text-white mb-1"> { stats?.total_failed_orders ?? '0' } </h3>
                                                <p className="text-white-50 mb-0">Failed Booking</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="card" style={{ 
                                    background: 'linear-gradient(135deg, #36b9cc 0%, #258391 100%)',
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <span className="avatar avatar-xl rounded-circle me-3" style={{ 
                                                backgroundColor: 'rgba(255,255,255,0.2)',
                                                padding: '15px'
                                            }}>
                                                {getCurrencyIcon()}
                                            </span>
                                            <div>
                                                <h3 className="text-white mb-1">{formatPrice(formattedTotalAmount, selectedCurrency)}</h3>
                                                <p className="text-white-50 mb-0">Total Amount</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="card booking-header" style={{ 
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    border: 'none'
                                }}>
                                    <div className="card-body">
                                        <form onSubmit={handleFormSubmit}>
                                            <div className="row g-3">
                                                {/* Booking Number */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="orderNumber" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-document-text1 me-1"></i>
                                                            Booking Number
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control shadow-none"
                                                            placeholder="Enter booking number"
                                                            name="orderNumber"
                                                            value={formData.orderNumber}
                                                            onChange={handleFormChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Holder Input */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="holder" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-user me-1"></i>
                                                            Guest Information
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control shadow-none"
                                                            placeholder="Enter holder name"
                                                            name="holder"
                                                            value={formData.holder}
                                                            onChange={handleFormChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Sub-Agency Input */}
                                                {userData.parent_id == null && (
                                                    <div className="col-lg-3 col-md-6">
                                                        <div className="filter-item">
                                                            <label htmlFor="agencyName" className="form-label text-muted small mb-2">
                                                                <i className="isax isax-building-3 me-1"></i>
                                                                Sub-Agency Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control shadow-none"
                                                                placeholder="Enter agency name"
                                                                name="agencyName"
                                                                value={formData.agencyName}
                                                                onChange={handleFormChange}
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Booking Date */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="orderDate" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-calendar-1 me-1"></i>
                                                            Booking Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control shadow-none"
                                                            name="orderDate"
                                                            value={formData.orderDate}
                                                            onChange={handleFormChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Check-in Date */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="checkInDate" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-login-1 me-1"></i>
                                                            Check-in Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control shadow-none"
                                                            name="checkInDate"
                                                            value={formData.checkInDate}
                                                            onChange={handleFormChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Check-out Date */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="checkOutDate" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-logout-1 me-1"></i>
                                                            Check-out Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control shadow-none"
                                                            name="checkOutDate"
                                                            value={formData.checkOutDate}
                                                            onChange={handleFormChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Hotel Input */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="hotelName" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-building-4 me-1"></i>
                                                            Hotel Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control shadow-none"
                                                            placeholder="Enter hotel name"
                                                            name="hotelName"
                                                            value={formData.hotelName}
                                                            onChange={handleFormChange}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Payment Status */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="payment-status-select" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-status-up me-1"></i>
                                                            Payment Status
                                                        </label>
                                                        <Select
                                                            id="payment-status-select"
                                                            value={formData.status}
                                                            onChange={(selectedOption) => setFormData({ ...formData, status: selectedOption })}
                                                            options={statusOptions}
                                                            placeholder="Select status"
                                                            isClearable
                                                            className="shadow-none"
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    minHeight: '38px',
                                                                    border: '1px solid #dee2e6',
                                                                    '&:hover': {
                                                                        border: '1px solid #dee2e6'
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Ülke seçimi */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="country-select" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-global me-1"></i>
                                                            Country
                                                        </label>
                                                        <Select
                                                            id="country-select"
                                                            value={selectedCountry}
                                                            onChange={(selectedOption) => {
                                                                setSelectedCountry(selectedOption);
                                                                setSelectedState(null);
                                                                setSelectedCity(null);
                                                                setFormData({ ...formData, countryId: selectedOption?.value || "", stateId: "", cityId: "" });
                                                                if (selectedOption) {
                                                                    fetchStates(selectedOption.value);
                                                                }
                                                            }}
                                                            options={countries.map(country => ({
                                                                value: country.id,
                                                                label: country.name
                                                            }))}
                                                            placeholder="Select country"
                                                            isClearable
                                                            className="shadow-none"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Eyalet seçimi */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="state-select" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-map me-1"></i>
                                                            State
                                                        </label>
                                                        <Select
                                                            id="state-select"
                                                            value={selectedState}
                                                            onChange={(selectedOption) => {
                                                                setSelectedState(selectedOption);
                                                                setSelectedCity(null);
                                                                setFormData({ ...formData, stateId: selectedOption?.value || "", cityId: "" });
                                                                if (selectedOption) {
                                                                    fetchCities(selectedOption.value);
                                                                }
                                                            }}
                                                            options={states.map(state => ({
                                                                value: state.id,
                                                                label: state.name
                                                            }))}
                                                            placeholder="Select state"
                                                            isClearable
                                                            isDisabled={!selectedCountry}
                                                            className="shadow-none"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Şehir seçimi */}
                                                <div className="col-lg-3 col-md-6">
                                                    <div className="filter-item">
                                                        <label htmlFor="city-select" className="form-label text-muted small mb-2">
                                                            <i className="isax isax-building me-1"></i>
                                                            City
                                                        </label>
                                                        <Select
                                                            id="city-select"
                                                            value={selectedCity}
                                                            onChange={(selectedOption) => {
                                                                setSelectedCity(selectedOption);
                                                                setFormData({ ...formData, cityId: selectedOption?.value || "" });
                                                            }}
                                                            options={cities.map(city => ({
                                                                value: city.id,
                                                                label: city.name
                                                            }))}
                                                            placeholder="Select city"
                                                            isClearable
                                                            isDisabled={!selectedState}
                                                            className="shadow-none"
                                                        />
                                                    </div>
                                                </div>


                                                {/* Filter ve Reset Butonları */}
                                                <div className="col-12 d-flex gap-2 justify-content-end">
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2"
                                                        onClick={handleFormReset}
                                                        style={{ minWidth: '120px' }}
                                                    >
                                                        <i className="isax isax-refresh"></i>
                                                        Reset
                                                    </button>
                                                    <button 
                                                        type="submit" 
                                                        className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                                                        disabled={buttonLoading}
                                                        style={{ minWidth: '120px' }}
                                                    >
                                                        <i className="isax isax-filter-search"></i>
                                                        {buttonLoading ? 'Filtering...' : 'Apply Filters'}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="card hotel-list" style={{ 
                                    borderRadius: '15px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    overflow: 'hidden'
                                }}>
                                    <div className="card-body p-0">
                                        <div className="custom-datatable-filter table-responsive">
                                            {!loading && orders?.length > 0 ? (
                                                <>
                                                    {/* Export Buttons */}
                                                    <div style={{ 
                                                        marginBottom: "10px", 
                                                        paddingBlock: '20px', 
                                                        paddingInline: '20px', 
                                                        textAlign: 'end',
                                                        display: 'flex',
                                                        gap: '10px',
                                                        justifyContent: 'flex-end'
                                                    }}>
                                                        <button 
                                                            onClick={handleExportToPdf} 
                                                            className='btn d-flex align-items-center gap-2'
                                                            style={{ 
                                                                borderRadius: '10px',
                                                                background: 'linear-gradient(135deg, #e74a3b 0%, #be2617 100%)',
                                                                border: 'none',
                                                                color: 'white',
                                                                padding: '10px 20px',
                                                                boxShadow: '0 4px 15px rgba(231, 74, 59, 0.3)'
                                                            }}
                                                        >
                                                            <i className="isax isax-document-download"></i>
                                                            Export PDF
                                                        </button>
                                                        <button 
                                                            onClick={handleExportToExcel} 
                                                            className='btn d-flex align-items-center gap-2'
                                                            style={{ 
                                                                borderRadius: '10px',
                                                                background: 'linear-gradient(135deg, #1cc88a 0%, #13855c 100%)',
                                                                border: 'none',
                                                                color: 'white',
                                                                padding: '10px 20px',
                                                                boxShadow: '0 4px 15px rgba(28, 200, 138, 0.3)'
                                                            }}
                                                        >
                                                            <i className="isax isax-document-download"></i>
                                                            Export Excel
                                                        </button>
                                                    </div>

                                                    {tableLoading ? (
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', margin: '50px' }}>
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="orders-list">
                                                            <table className="table table-hover mb-0">
                                                                
                                                                <tbody>
                                                                    {orders.map((order) => (
                                                                        <React.Fragment key={order.id}>
                                                                            <tr 
                                                                                style={{ 
                                                                                    cursor: 'pointer',
                                                                                    transition: 'all 0.3s ease'
                                                                                }}
                                                                                onClick={() => toggleOrder(order.id)}
                                                                            >
                                                                                <td style={{ padding: '15px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <i className={`isax isax-arrow ${expandedOrders[order.id] ? 'isax-arrow-up-2' : 'isax-arrow-down-2'} me-2`} style={{ 
                                                                                            fontSize: '20px',
                                                                                            color: '#4e73df'
                                                                                        }}></i>
                                                                                        <strong style={{ color: '#2c3e50' }}>#{order.order_number}</strong>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ padding: '15px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                                                                    <span className="badge" style={{ 
                                                                                        borderRadius: '8px',
                                                                                        background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                                                                        padding: '5px 10px',
                                                                                        color: 'white'
                                                                                    }}>
                                                                                        {formatDate(order.order_datetime)}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{ padding: '15px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                                                                    <span className={`badge ${order.status === 'pending' ? 'bg-warning' : order.status === 'success' ? 'bg-success' : 'bg-danger'}`} style={{ 
                                                                                        borderRadius: '8px',
                                                                                        padding: '5px 10px'
                                                                                    }}>
                                                                                        {order.status}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{ padding: '15px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                                                                    <strong style={{ color: '#2c3e50' }}>
                                                                                        {orderPrices[`order_${order.id}`] || order.total_with_markup_price} {selectedCurrency}
                                                                                    </strong>
                                                                                </td>
                                                                                <td style={{ padding: '15px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                                                                                    <button 
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            handleView(order.id);
                                                                                        }}
                                                                                        className="btn btn-sm d-flex align-items-center gap-2"
                                                                                        style={{ 
                                                                                            borderRadius: '8px',
                                                                                            background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                                                                            border: 'none',
                                                                                            color: 'white',
                                                                                            padding: '5px 10px',
                                                                                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                                                                                        }}
                                                                                    >
                                                                                        <i className="isax isax-eye"></i>
                                                                                        View Details
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                            {expandedOrders[order.id] && (
                                                                                <tr>
                                                                                    <td colSpan="5" style={{ padding: '0', border: 'none' }}>
                                                                                        <div className="order-content p-3" style={{ 
                                                                                            backgroundColor: '#fff',
                                                                                            borderBottom: '1px solid rgba(0,0,0,0.1)',
                                                                                            width: '100%'
                                                                                        }}>
                                                                                            <div className="hotels-list" style={{ width: '100%' }}>
                                                                                                {order.grouped_hotels?.map((hotel) => (
                                                                                                    <div className="hotel-card mb-3" key={hotel.id} style={{ 
                                                                                                        width: '100%',
                                                                                                        maxWidth: '100%'
                                                                                                    }}>
                                                                                                        <div 
                                                                                                            className="hotel-header p-3 d-flex justify-content-between align-items-center"
                                                                                                            style={{ 
                                                                                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                                                                                cursor: 'pointer',
                                                                                                                borderRadius: '12px',
                                                                                                                border: '1px solid rgba(0,0,0,0.1)',
                                                                                                                transition: 'all 0.3s ease',
                                                                                                                width: '100%'
                                                                                                            }}
                                                                                                            onClick={() => toggleHotel(hotel.id)}
                                                                                                        >
                                                                                                            <div className="d-flex align-items-center" style={{ width: '100%' }}>
                                                                                                                <div className="me-3">
                                                                                                                    <i className={`isax isax-arrow ${expandedHotels[hotel.id] ? 'isax-arrow-up-2' : 'isax-arrow-down-2'}`} style={{ 
                                                                                                                        fontSize: '16px',
                                                                                                                        color: '#4e73df'
                                                                                                                    }}></i>
                                                                                                                </div>
                                                                                                                <div style={{ flex: 1 }}>
                                                                                                                    <h5 className="mb-1" style={{ 
                                                                                                                        color: '#2c3e50',
                                                                                                                        fontSize: '14px',
                                                                                                                        fontWeight: '600'
                                                                                                                    }}>
                                                                                                                        {hotel.name}
                                                                                                                    </h5>
                                                                                                                    <span className="badge" style={{ 
                                                                                                                        borderRadius: '8px',
                                                                                                                        background: 'linear-gradient(135deg, #36b9cc 0%, #258391 100%)',
                                                                                                                        padding: '4px 8px',
                                                                                                                        fontSize: '12px'
                                                                                                                    }}>
                                                                                                                        {hotel.category?.description}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <span style={{ 
                                                                                                                        borderRadius: '8px',
                                                                                                                        backgroundColor: hotel.status === 'cancelled' ? 'red' : hotel.status === 'confirmed' ? 'green' : hotel.status === 'pending' ? 'yellow' : 'gray',
                                                                                                                        padding: '5px 10px',
                                                                                                                        fontSize: '12px',
                                                                                                                        color: 'white',
                                                                                                                        fontWeight: 'bold',
                                                                                                                        marginRight: '30px'
                                                                                                                    }}>
                                                                                                                        {hotel.status.toUpperCase()}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                                <div className="text-end">
                                                                                                                    <h4 className="mb-0" style={{ 
                                                                                                                        color: '#2c3e50',
                                                                                                                        fontWeight: '600',
                                                                                                                        fontSize: '14px'
                                                                                                                    }}>
                                                                                                                        {orderPrices[`hotel_${hotel.id}`] || hotel.total_with_markup_price} {selectedCurrency}
                                                                                                                    </h4>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        {expandedHotels[hotel.id] && (
                                                                                                            <div className="hotel-content p-3">
                                                                                                                {hotel.items?.map((item) => (
                                                                                                                    <div className="item-card mb-3" key={item.id} style={{ 
                                                                                                                        borderRadius: '12px',
                                                                                                                        border: '1px solid rgba(0,0,0,0.1)',
                                                                                                                        overflow: 'hidden',
                                                                                                                        background: '#fff'
                                                                                                                    }}>
                                                                                                                        <div className="card-body">
                                                                                                                            <div className="row">
                                                                                                                                <div className="col-md-6">
                                                                                                                                    <div className="section-title mb-3">
                                                                                                                                        <i className="isax isax-home me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                        <h6 className="d-inline-block mb-0" style={{ color: '#2c3e50' }}>Room Details</h6>
                                                                                                                                    </div>
                                                                                                                                    <div className="details-list">
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-building me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Room:</strong> {item.room_name}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-cup me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Board:</strong> {item.board_name}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-calendar me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Check-in:</strong> {formatDate(item.check_in_date)}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-calendar me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Check-out:</strong> {formatDate(item.check_out_date)}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-moon me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Nights:</strong> {item.nights}
                                                                                                                                        </p>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                                <div className="col-md-6">
                                                                                                                                    <div className="section-title mb-3">
                                                                                                                                        <i className="isax isax-user me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                        <h6 className="d-inline-block mb-0" style={{ color: '#2c3e50' }}>Guest Information</h6>
                                                                                                                                    </div>
                                                                                                                                    <div className="details-list">
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-user me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Adults:</strong> {item.adults_count}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-user me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Children:</strong> {item.children_count}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-people me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Total Guests:</strong> {item.total_guests}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-dollar-circle me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Price:</strong> {orderPrices[`item_${item.id}`] || item.with_markup_price} {selectedCurrency}
                                                                                                                                        </p>
                                                                                                                                        <p className="mb-2">
                                                                                                                                            <i className="isax isax-status-up me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                            <strong>Status:</strong> 
                                                                                                                                            <span className={`badge ${item.status === 'confirmed' ? 'bg-success' : item.status === 'cancelled' ? 'bg-danger' : item.status === 'pending' ? 'bg-warning' : item.status === 'on_request' ? 'bg-info' : 'bg-secondary'}`} style={{ 
                                                                                                                                                borderRadius: '8px',
                                                                                                                                                padding: '5px 10px',
                                                                                                                                                marginLeft: '5px'
                                                                                                                                            }}>
                                                                                                                                                {item.status}
                                                                                                                                            </span>
                                                                                                                                        </p>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </div>

                                                                                                                            {item.cancellation_policies?.length > 0 && (
                                                                                                                                <div className="mt-4">
                                                                                                                                    <div className="section-title mb-3">
                                                                                                                                        <i className="isax isax-warning-2 me-2" style={{ color: '#4e73df' }}></i>
                                                                                                                                        <h6 className="d-inline-block mb-0" style={{ color: '#2c3e50' }}>Cancellation Policies</h6>
                                                                                                                                    </div>
                                                                                                                                    <div className="row">
                                                                                                                                        <div className="col-md-4 mb-3">
                                                                                                                                            <div className="card h-100 border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)' }}>
                                                                                                                                                <div className="card-body p-3">
                                                                                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                                                                                        <div className="rounded-circle bg-success p-2 me-2">
                                                                                                                                                            <i className="isax isax-tick-circle text-white"></i>
                                                                                                                                                        </div>
                                                                                                                                                        <h6 className="mb-0 text-success">Free Cancellation</h6>
                                                                                                                                                    </div>
                                                                                                                                                    <p className="mb-0 small text-success">
                                                                                                                                                        Until {formatDate(item.cancellation_policies[0].from)}
                                                                                                                                                    </p>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </div>

                                                                                                                                        <div className="col-md-4 mb-3">
                                                                                                                                            <div className="card h-100 border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)' }}>
                                                                                                                                                <div className="card-body p-3">
                                                                                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                                                                                        <div className="rounded-circle bg-warning p-2 me-2">
                                                                                                                                                            <i className="isax isax-info-circle text-white"></i>
                                                                                                                                                        </div>
                                                                                                                                                        <h6 className="mb-0 text-warning">Cancellation Fee</h6>
                                                                                                                                                    </div>
                                                                                                                                                    <p className="mb-0 small text-warning">
                                                                                                                                                        {formatDate(item.cancellation_policies[0].from)} - {formatDate(item.check_in_date)}
                                                                                                                                                        <br/>
                                                                                                                                                        <span className="fw-semibold">
                                                                                                                                                            Fee: {cancellationPrices[`policy_${item.id}_${item.cancellation_policies[0].from}`] || item.cancellation_policies[0].amount} {selectedCurrency}
                                                                                                                                                        </span>
                                                                                                                                                    </p>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </div>

                                                                                                                                        <div className="col-md-4 mb-3">
                                                                                                                                            <div className="card h-100 border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%)' }}>
                                                                                                                                                <div className="card-body p-3">
                                                                                                                                                    <div className="d-flex align-items-center mb-2">
                                                                                                                                                        <div className="rounded-circle bg-danger p-2 me-2">
                                                                                                                                                            <i className="isax isax-danger text-white"></i>
                                                                                                                                                        </div>
                                                                                                                                                        <h6 className="mb-0 text-danger">Non-Refundable</h6>
                                                                                                                                                    </div>
                                                                                                                                                    <p className="mb-0 small text-danger">
                                                                                                                                                        After {formatDate(item.check_in_date)}
                                                                                                                                                        <br/>
                                                                                                                                                        <span className="fw-semibold">
                                                                                                                                                            Full amount will be charged
                                                                                                                                                        </span>
                                                                                                                                                    </p>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                ))}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </React.Fragment>
                                                                    ))}
                                                                </tbody>
                                                            </table>

                                                            {/* Pagination */}
                                                            <div className="d-flex justify-content-between align-items-center p-3" style={{ 
                                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                                borderTop: '1px solid rgba(0,0,0,0.1)'
                                                            }}>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className="text-muted">Show</span>
                                                                    <select 
                                                                        className="form-select form-select-sm" 
                                                                        style={{ width: '70px' }}
                                                                        value={perPage}
                                                                        onChange={(e) => handlePerRowsChange(Number(e.target.value), 1)}
                                                                    >
                                                                        <option value={10}>10</option>
                                                                        <option value={25}>25</option>
                                                                        <option value={50}>50</option>
                                                                        <option value={100}>100</option>
                                                                    </select>
                                                                    <span className="text-muted">entries</span>
                                                                </div>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <button 
                                                                        className="btn btn-sm"
                                                                        style={{ 
                                                                            borderRadius: '8px',
                                                                            background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                                                            border: 'none',
                                                                            color: 'white',
                                                                            padding: '5px 10px'
                                                                        }}
                                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                                        disabled={currentPage === 1}
                                                                    >
                                                                        Previous
                                                                    </button>
                                                                    <span className="text-muted">
                                                                        Page {currentPage} of {Math.ceil(totalRows / perPage)}
                                                                    </span>
                                                                    <button 
                                                                        className="btn btn-sm"
                                                                        style={{ 
                                                                            borderRadius: '8px',
                                                                            background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                                                            border: 'none',
                                                                            color: 'white',
                                                                            padding: '5px 10px'
                                                                        }}
                                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                                        disabled={currentPage === Math.ceil(totalRows / perPage)}
                                                                    >
                                                                        Next
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : !loading ? (
                                                <div style={{ padding: "50px" }} className="d-flex justify-content-center align-items-center">
                                                    <p style={{ textAlign: "center", margin: "auto", width: "100%", color: '#6c757d' }}>
                                                        No data available.
                                                    </p>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                </div>
            </div>
        </div>
    </Layout>
)
}